/**
 * Main Menu
 */
;(function($) {
  // Accesible toggle menu
  // $('#nav-primary').accessibleMegaMenu({
  //   uuidPrefix: 'amenu',
  //   menuClass: 'amenu__main',
  //   topNavItemClass: 'amenu__top',
  //   panelClass: 'amenu__panel',
  //   panelGroupClass: 'sub-menu',
  //   hoverClass: 'hover',
  //   focusClass: 'focus',
  //   openClass: 'open',
  // })
  // $('.amenu__toggle')
  // // Regular WordPress Menu
  // $('.menu-footer-container').accessibleMegaMenu({
  //   uuidPrefix: 'amenu',
  //   menuClass: 'menu',
  //   topNavItemClass: 'menu__top',
  //   panelClass: 'menu__panel',
  //   panelGroupClass: 'sub-menu',
  //   hoverClass: 'hover',
  //   focusClass: 'focus',
  //   openClass: 'open',
  // })
  var body = $('body')
  $('.amenu__toggle').on('click', function(e) {
    var ww = $(window).width()
    if (ww < 768) {
      e.preventDefault()
      var $this = $(this)
      var panel = $('.amenu__panel')
      var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
      var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
      body.toggleClass('menu-main-open')
      panel.toggleClass('open')
      $this.attr('aria-expanded', expandend)
      panel.attr('aria-expanded', expandend)
      panel.attr('aria-hidden', hidden)
    } else {
      body.addClass('menu-revisible')
    }
  })
  var headerHeight = $('#header').outerHeight()
  //  var prevScrollpos = $(window).scrollTop()
  $(window).on('scroll', function() {
    var currentScrollpos = $(window).scrollTop()
    if (currentScrollpos > headerHeight) {
      body.addClass('menu-hide')
      body.removeClass('menu-revisible')
      $('.main__content').css('margin-top', headerHeight)
    } else {
      body.removeClass('menu-hide')
      $('.main__content').css('margin-top', 0)
    }
  })
})(jQuery)
